"use client";

import { Check, type LucideIcon } from "lucide-react";

/**
 * Carte de choix du thème sombre marketing.
 *
 * Reprend le vocabulaire visuel du sélecteur de la page tarifs (menthe à 7 %
 * + bordure à 30 % pour l'état actif, `glass-card` sinon), pour que le parcours
 * de contact ne ressemble pas à une pièce rapportée.
 */
export function ChoiceCard({
  icon: Icon,
  label,
  hint,
  active,
  onSelect,
}: {
  icon?: LucideIcon;
  label: string;
  hint?: string;
  active: boolean;
  onSelect: () => void;
}) {
  return (
    <button
      type="button"
      onClick={onSelect}
      aria-pressed={active}
      className={`relative flex w-full items-start gap-3 rounded-xl px-4 py-4 text-left transition-all duration-300 cursor-pointer ${
        active
          ? "bg-primary/[0.07] border border-primary/30"
          : "glass-card hover:bg-white/[0.06]"
      }`}
    >
      {Icon && (
        <Icon
          className={`mt-0.5 h-5 w-5 shrink-0 transition-colors duration-300 ${
            active ? "text-primary" : "text-muted-foreground"
          }`}
        />
      )}
      <span className="min-w-0 flex-1">
        <span className="block text-sm font-medium text-card-foreground">
          {label}
        </span>
        {hint && (
          <span className="mt-0.5 block text-xs text-muted-foreground">
            {hint}
          </span>
        )}
      </span>
      {active && <Check className="mt-0.5 h-4 w-4 shrink-0 text-primary" />}
    </button>
  );
}
